import * as yup from 'yup'

const schema = yup.object().shape({
  phone: yup.string().phone({ required: true }),
})

export default schema
